import { SteemActionType } from '@popup/steem/actions/action-type.enum';
const DelegationsReducer = (state = {
    incoming: [],
    outgoing: [],
    pendingOutgoingUndelegation: [],
}, { type, payload }) => {
    switch (type) {
        case SteemActionType.FETCH_DELEGATEES:
            return Object.assign(Object.assign({}, state), { outgoing: payload.outgoing });
        case SteemActionType.FETCH_DELEGATORS:
            return Object.assign(Object.assign({}, state), { incoming: payload.incoming });
        case SteemActionType.FETCH_PENDING_OUTGOING_UNDELEGATION:
            return Object.assign(Object.assign({}, state), { pendingOutgoingUndelegation: payload.pendingOutgoingUndelegation });
        default:
            return state;
    }
};
export default DelegationsReducer;
